// extracted by mini-css-extract-plugin
export default {"container":"container__fEcGm","grid":"grid__1eAe2","smallThanks":"smallThanks__NhFaX"};